// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/web-" + {"179":"components","407":"panel","666":"styleguide","818":"default"}[chunkId] + ".css";
};